import React from "react";

import {
  Container,
  Text,
  Logo,
  Content,
  ButtonLink,
  SubText,
} from "./styles/footer";

export default function Footer({ children, ...restProps }) {
  return <Container {...restProps}> {children} </Container>;
}

Footer.Text = function FooterText({ children, ...restProps }) {
  return <Text {...restProps}>{children}</Text>;
};

Footer.SubText = function FooterSubText({ children, ...restProps }) {
  return <SubText {...restProps}>{children}</SubText>;
};

Footer.Logo = function FooterLogo({ children, ...restProps }) {
  return <Logo {...restProps} />;
};

Footer.Content = function FooterContent({ children, ...restProps }) {
  return <Content {...restProps} />;
};

Footer.ButtonLink = function FooterButtonLink({ children, ...restProps }) {
  return <ButtonLink {...restProps}>{children} </ButtonLink>;
};
